import { createStyles } from '@zn-material-ui'
export default () =>
  createStyles({
    card: {
      boxShadow: 'none',
      width: '310px',
    },
    title: {
      fontSize: 16,
      color: '#000',
      borderBottom: '1px solid #E5E5E5',
      height: 50,
      boxSizing: 'border-box',
      lineHeight: '50px',
      paddingLeft: '26px',
      // fontWeight: 'bold'
    },
    detail: {
      height: '120px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '0 20px',
      '& li': {
        float: 'left',
        textAlign: 'center',
        color: '#99999',
        fontSize: '14px',
        '& span': {
          display: 'block',
          color: '#999',
          wordWrap: 'break-word',
          wordBreak: 'normal',
          overflowWrap: 'break-word',
        },
      },
    },
    numbers: {
      fontSize: '22px',
      color: '#2E3039 !important',
      marginBottom: '5px',
      fontWeight: 'bold',
    },
    /** 足迹列表样式 */
    box: {
      width: '100%',
      padding: '0 16px',
      boxSizing: 'border-box',
      '& *': {
        boxSizing: 'border-box',
        wordBreak: 'normal',
      },
      '& li': {
        fontSize: '14px',
        borderRadius: '2px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        wordBreak: 'normal',
        paddingLeft: '12px',
        '&:hover': {
          background: '#F5F5F5',
        },
      },
    },
    icon: {
      width: '20px',
      height: '20px',
      marginRight: '6px',
    },
    timeSecond: {
      color: '#999',
      marginRight: '10px',
    },
    recordName: {
      color: '#333333',
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    ymd: {
      fontSize: '14px',
      color: '#666',
      height: '40px',
      lineHeight: '40px',
      paddingLeft: '20px',
    },
    oneDay: {
      position: 'relative',
    },
    redDot: {
      position: 'absolute',
      width: '8px',
      height: '8px',
      borderRadius: '4px',
      background: '#FA534A',
      top: '16px',
      left: '-3px',
      zIndex: 1,
    },
    listUl: {
      borderLeft: '1px solid #E5E5E5',
    },
  })
